let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("R0Tey")).then(() => parcelRequire('9napL'));